import { useEffect, useState } from "react";
import React from 'react'

const usePersist = () => {
    const [persist, setPersist] = useState(JSON.parse(localStorage.getItem("persist")) || false)
    // Parsing means analyzing and converting a program into an internal format that a runtime environment can actually run

    useEffect(()=>{
        localStorage.setItem("persist", JSON.stringify(persist))
        // the JSON.stringify() static method converts a JavaScript value to a JSON string,
    },[persist])
  return [persist, setPersist]
}

export default usePersist